import type {ComponentType} from 'react';
import {STATIC_PATH} from '../../config/config';
import type {AiAgentIntent} from '../../redux/aiAgent/aiAgent.type';
import AiAgentCalendarIcon from '../../assets/icons/AiAgentCalendarIcon';
import AiAgentTicketsIcon from '../../assets/icons/AiAgentTicketsIcon';

const VIDEO_PATH = `${STATIC_PATH}images/app/aiAgent`;

/** The FAB and the empty state share one video, and with it one poster frame. */
const ASSISTANT_VIDEO_SRC = `${VIDEO_PATH}/assistant-fab-star.mp4`;
// The poster is the reduced-motion fallback, so it has to exist: assistant-fab-star-poster.jpg
// was never uploaded and returns 403. Point a dedicated FAB frame here once one is on S3.
const ASSISTANT_POSTER_SRC = `${VIDEO_PATH}/assistant-fab-poster.jpg`;

export const AI_AGENT_MEDIA = {
    fab: {
        src: ASSISTANT_VIDEO_SRC,
        poster: ASSISTANT_POSTER_SRC,
    },
    empty: {
        src: ASSISTANT_VIDEO_SRC,
        poster: ASSISTANT_POSTER_SRC,
    },
} as const;

interface AiAgentSuggestionConfig {
    labelKey: string;
    promptKey: string;
    Icon: ComponentType<{width?: number; height?: number; fill?: string}>;
    /** Only offered where the intent can actually run — see isIntentAvailableInScope. */
    intent: AiAgentIntent;
}

export const AI_AGENT_SUGGESTIONS: AiAgentSuggestionConfig[] = [
    {
        labelKey: 'suggestionCreateEvent',
        promptKey: 'promptCreateEvent',
        Icon: AiAgentCalendarIcon,
        intent: 'CREATE_EVENT',
    },
    {
        labelKey: 'suggestionCreateTicket',
        promptKey: 'promptCreateTicket',
        Icon: AiAgentTicketsIcon,
        intent: 'CREATE_TICKET',
    },
];
